import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { TranslateService } from "@ngx-translate/core";
import { SearchHeaderService } from "../../services/SsearchHeader.service";

import moment from "moment";
import { PatientNotesDialogComponent } from "../patient-notes-dialog/patient-notes-dialog.component";
import { Subject, Subscription } from "rxjs";
import {  takeUntil } from "rxjs/operators";
import { removeSpaces } from "../../helper/helper.service";
import { mandatoryFields } from "../../properties/field-mandatory-properties";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { patientGetDataservice } from "../../services/SpatientGetData.service";
import { MasterUrlService } from "../../services/SmasterUrl.service";
import { CameraDialogComponent } from "../../shared/camera-dialog/camera-dialog.component";
import { RegsuccessDialogComponent } from "../../shared/regsuccess-dialog/regsuccess-dialog.component";
import {
  OPD_REPORT_NAME,
} from "../../properties/opd-report-properties";
import { mandatoryFieldsService } from "../../services/SmandatoryFields.service";
import { statisGlApprovalType } from "../../enums/encounter-status.enum";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { PatientRegistrationService } from "../../services/Spatient-registration.service";
import { OPD_CONST } from "projects/lib/medcare-core-lib/src/lib/regproperties/opd-static-properties";
import { MasterKeys, MasterSubMenus } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";
import { MASTERSSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/master-service";
import { STATICCODESERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/static-code-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { ConfirmDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dialog/confirm-dialog.component";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { InfoDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/info-dialog/info-dialog.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { Langauge, MasterMenus } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { BirthPlaceList } from "projects/lib/medcare-core-lib/src/lib/regproperties/birth-place";
import { EncounterSlipService } from "projects/lib/medcare-core-lib/src/lib/regservices/encounter-slip.service";
import { PatientLableService } from "projects/lib/medcare-core-lib/src/lib/regservices/patient-lable.service";
import { PdpaFormService } from "projects/lib/medcare-core-lib/src/lib/regservices/pdpa-form.service";
import { EncounterAppointmnetComponent } from "projects/lib/medcare-core-lib/src/lib/regshared/encounter-appointmnet/encounter-appointmnet.component";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { CopDecimalCalculateService } from "projects/lib/medcare-core-lib/src/lib/services/cop-decimal-calculate.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { PatientEncounterPayer, PatientRegistration } from "projects/lib/medcare-core-lib/src/lib/services/RegistationModel";
import { ReportService } from "projects/lib/medcare-core-lib/src/lib/services/report.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { UtilsService } from "projects/lib/medcare-core-lib/src/lib/services/utils.service";
import { MyKadData } from "projects/lib/medcare-core-lib/src/lib/regmodels/MmyKadData";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Identification } from "projects/lib/medcare-core-lib/src/lib/regmodels/MpatientRegistration";
@Component({
  selector: "app-sample-patient-registration",
  templateUrl: "./sample-patient-registration.component.html",
  styleUrls: ["./sample-patient-registration.component.scss"],
  providers: [DatePipe],
})
export class SamplePatientRegistrationComponent implements OnInit, OnDestroy {
  private subscriptionList = new Subscription();
  patientId: string = "";
  patientForm: boolean = true;
  patientImage: string = "";
  isDeceased: boolean = false;

  selectedPatient: any;
  searchCriteria: any = null;
  patientList: any[] = [];
  refreshTime: string = "";
  hidePatientSearch = false;
  isBothAddressSame: boolean = false;
  isSameAddress: boolean = false;
  formData: FormData = new FormData();
  fileUploadList: any[] = [];

  patientInfoDisplay: string = "";
  previousEncounterList: any[] = [];
  dataSourceEncounters = new MatTableDataSource<any>([]);
  fileSourceReg = new MatTableDataSource();
  fileUploadRegList: any[] = [];
  docTypeFilteredList: any[] = [];
  stateSecondaryList: any[] = [];
  countrySecondaryList: any[] = [];
  citySecondaryList: any[] = [];
  subDistrictSecondaryList: any[] = [];
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subDistrictPrimaryList: any[] = [];
  unitName: string;
  isRegistered: boolean = false;
  username: any;
  userId: any;
  usermasterid: any;
  patientTRN: string = "";
  isDisabled: boolean = false;
  countryValue: any = null;
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  isAdmissionRequest: boolean = false;
  admissionReqload: any;

  payerTypeSearch: FormControl = new FormControl();
  payerSearch: FormControl = new FormControl();
  tariffSearch: FormControl = new FormControl();
  contractCodeSearch: FormControl = new FormControl();
  associatedCompanySearch: FormControl = new FormControl();

  primaryIdList: any[] = [];

  appointmentReference: {
    appointmentDate?: string;
    bookingType?: string;
    appointmentNo?:string;
    appointmentId: string;
    tempPatientId: string;
    trnNumber: string;
    doctorCode: string;
    departmentCode: string;
  } = {
    appointmentId: "",
    tempPatientId: "",
    trnNumber: "",
    doctorCode: "",
    departmentCode: "",
  };

  genderValue: any = null;
  identifierTypeValue: any = null;
  titleValue: any = null;

  encounterTypeValue: any = null;
  departmentValue: any = null;
  doctorValue: any = null;
  departmentFilterList:any[]=[];
  departmentList:any[]=[];
  dipartmentSearch: FormControl = new FormControl();

  countrySecondaryValue: any = null;
  stateSecondaryValue: any = null;
  citySecondaryValue: any = null;
  secondaryCountryCode: any = null;
  secondaryStateCode: any = null;
  secondaryDistrictCode: any = null;

  districtSeoncdaryValue: any = null;
  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  minDate = moment().add(-200, "year");
  maxDate = new Date(this.year, this.month, this.day);
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  primaryIdRegex: string = OPD_CONST.primaryIdRegix;
  isexpiryDate: boolean = false;
  isValid: boolean = false;
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0",
    months: "0",
    days: "0",
  };
  masterAPI: any = MASTERSSERVICES;
  mandatoryField: any = mandatoryFields;
  unitCode: string;
      formRegistration: FormGroup; 
  //--End Registration Details---//

  formEncounter: FormGroup ;
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  isDepartment: boolean = true;
  isPassport: boolean = false;
  doctorSearch: FormControl = new FormControl();
  multiLangDoctorList: any[] = [];
  doctorList: any[] = [];
  doctorFilteredList: any[] = [];
  internalNotesList: any[] = [];
  previousInternalNotes: any[] = [];
  internotesEncounterid: any;
  selected: string;
  encounternumber: string = "";

  //-----Encounter Details End Here-----//

  //payer Details//
  displayedColumnsPayers: string[] = OPD_CONST.displayColumnPayers;
  dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([]);
  payerList: any[] = [];
  payerTypeList: any[] = [];
  tariffList: any[] = [];
  contractList: any[] = [];
  associatedCompanyList: any[] = [];
  glTypeList: any[] = [];
  referralTypeCode: any = null;

  payerTypeFilteredList: any;
  payerFilteredList: any;
  tariffFilteredList: any;
  contractCodeList: any;
  associatedCompanyCodeList: any;
  docList: any;
  ////---payer Ends Here---//
  admissionStatus:boolean;
  reasonSample: any[]=[];
  reasonList: any[]=[];
  reasonSearch: FormControl = new FormControl();
  isStaffActive:boolean=false;
  isPatientCategory: boolean =false;
  displayedColumnsEncounters: string[] = OPD_CONST.displayColumnRegEncounters;
  imageUrl: string = "";
  isSave: boolean = true;
  isFirstPayerPriority: boolean;
  
  private socket: WebSocket;
  identificationTypeList: any[];
  genderList: any[] = [];
  mandatorykeys: mandatoryFieldsService = new mandatoryFieldsService();
  primaryIdFilteredList: any[]=[];
  defaultGender: {
    id: number;
    code: string;
    desc: string;
  };
  secondaryIdList: any[] = [];
  secondaryIdFilteredList: any[] = [];
  contractValue: any = [];
  existingPayerList: any[];
  pdpaForm: boolean = false;
  isVip: boolean = false;
  isNoteVisible?:string
  mobileNoMin:number=8;
  mobileNoMax:number=14;
  isDefaultDeposit: boolean = false;
  defaultDeposit: string = "";
  orgCode: string='';
  defaultCountry: string='';
  countryCode: string;
  countryCodeLists: any[]=[];
  reasonCode: object;
  output: string;
  selectedPrimaryId: any;
  isPrimaryNoEditable: boolean=false;
  doctorValueappointment: any;
  tokenNoValue: string = "";
  isToken: boolean = false;
  isFromAppointment: boolean = false;
    langaugeValue:string="";
  primaryIdSearch: FormControl = new FormControl();
  isOtherReferral: boolean = false;
  othersReferral:string="";
  primaryIdCode: any;
  defaultIdentification: string='';
  primaryIdNewValue: string;
  isCompany: boolean = false;
  tariffCompanyList: any;
  defaultTariff: any;
  isContract: boolean = false;
  minIdentificationLength:number=0;
  maxIdentificationLength:number=20;
 displayedColumns: string[] = OPD_CONST.identificationTable;
   identificationList = new MatTableDataSource<Identification>([]);
   @ViewChild(MatTable) tableidentification!: MatTable<Identification>;
   selectedPatientIdentificationList:Identification[]=[];
  primaryIdentifierListModified: boolean;
  secondaryIdentifierListModified: boolean;
  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private searchService: SearchService,
    private appBaseService: AppBaseService,
    public translate: TranslateService,
    public authService: AuthService,
    private patientService: PatientService,
    public applicationConfig: ApplicationConfigService,
    private patientRegService: PatientRegistrationService,
    private langService: MultiLanguageService,
    public searchHead: SearchHeaderService,
    public generalApiService: GeneralUrlService,
    public masterApiService: MasterUrlService,
    public patientDataService: patientGetDataservice,
    private router: Router,
    private utilsService: UtilsService,
    private datepipe: DatePipe,
    private reportService: ReportService,
    private env: EnvoirnmentService,
    private patientLableService:PatientLableService,
    private encounterSlipService:EncounterSlipService,
    private pdpaFormService:PdpaFormService,
    private inputValidation:CopDecimalCalculateService,
    private http: HttpClient,
    private thConvertService:thEnConverterService,
    private cdr: ChangeDetectorRef

  ) {
    this.getScreenConfigurations();
    this.getPrimaryIdList();    
    this.getAppConfigList();
  }

  /**
   *load method
   *
   * @memberof SamplePatientRegistrationComponent
   */
  ngOnInit() {    
    this.addEmptyIdentificationEntry("P");
    this.formRegistration = this.formBuilder.group({
      id: [""],
    active:[false],
    isVip: [false],
    isNewborn: [false],
    mrn: [""],
    primaryId: [""],
    primaryNumber: [null, [removeSpaces]],
    expiryDate: [""],
    issuedCountryPrimary: [""],
    secondaryId: [""],
    secondaryNumber: ["", [removeSpaces]],
    issuedCountrySecondary: [""],
    faculty: [""],
    firstName: [null, [removeSpaces]],
    aliasName: [{value: '', disabled: true}, [removeSpaces]],
    dateOfBirth: [""],
    realdob: [false],
    prefix: [""],
    gender: [""],
    race: [""],
    nation: [""],
    patientCategory: [""],
    martial: [""],
    occupation: [""],
    preferredLanguage: [""],
    bloodGroup: [""],
    religion: [""],
    isDeceased: [false],
    isBlock: [false],
    isCtos: [false],
    sourceType: [""],
    patientNotes: [null, [removeSpaces]],
    addressPrimary: [null, [removeSpaces]],
    countryPrimary: [""],
    statePrimary: [""],
    cityPrimary: [""],
    subDistrictPrimary: [""],
    homeContact: [""],
    personalFax: [""],
    education: [""],
    birthplace: [""],
    workFax: [""],
    motherName: [""],
    ethnic: [""],
    mobileNumber: [""],
    addressSecondary: [null, [removeSpaces]],
    countrySecondary: [""],
    stateSecondary: [""],
    citySecondary: [""],
    subDistrictSecondary: [""],
    workContact: [""],
    contactRelation: [""],
    pincodePrimary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    pincodeSecondary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    emailId: [
      "",
      Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"),
    ],
    birthTime: [""],
    countryCodemobile: [""],
    secondaryExpirydate: [""],
    });
  
    //--End Registration Details---//
  
    this.formEncounter = this.formBuilder.group({
      visitToDepartment: [""],
      encounterType: ["", Validators.required],
      department: ["", Validators.required],
      doctor: ["", Validators.required],
      clinic: [""],
      cashCounter: [""],
      remarks: [null, [removeSpaces]],
      queueNumber: [""],
      referralType: [""],
      referral: [""],
      reportType: [""],
      reportReason: [""],
      patientCategory: [""],
      practiceNotes: [null, [removeSpaces]],
      visittype: [""],
      referralRemarks: [null, [removeSpaces]],
      reportRemarks: [null, [removeSpaces]],
    });
    this.getCountryCode()
    this.imageUrl = this.env.apiUrl;
    this.reasonCode = OPD_CONST.reasonCode;
    this.getPreviousPayerList();
    // let patientEncounterPayer = new PatientEncounterPayer();
    // patientEncounterPayer.isSelf = true;
   
    // this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>([
    //   patientEncounterPayer,
    // ]);
    this.langaugeValue=localStorage.getItem("lan");
    this.getUnitData();
    this.searchOnChanges();
    this.fillDropDownLists();
    this.initSearchFilter();
    // this.getOrgAppConfigList();
    this.initMyKadCardReader();
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
    });
    this.onChanges();
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  onChanges() {
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonSample = this.reasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.primaryIdSearch.valueChanges.subscribe((value) => {
        this.primaryIdFilteredList = this.primaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.formEncounter.controls["patientCategory"].valueChanges.subscribe((value) => {
        this.getTariffList(0);
      })
    );
    
  }

  /**
   *get user info details
   *
   * @memberof PatientRegistrationComponent
   */
  getUserInfo() {
    this.authService.getUserInfo().then((value: any) => {
      this.username = value.userName;
      this.userId = value.userId;
      this.usermasterid = value.user_code;
    });
  }

  /**
   * To get unit data
   * @memberof SamplePatientRegistrationComponent
   */
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.getAppConfigurationList();
      this.getOrgAppConfigList();
    });
  }

  /**
   *Reeading values from Mykad
   *
   * @memberof PatientRegistrationComponent
   */
  initMyKadCardReader() {
    try {
      this.getMyKadMasters();
      this.socket = new WebSocket("ws://localhost:8888");

      this.socket.onopen = () => {
        console.log("WebSocket connection established.");
      };

      this.socket.onmessage = (event) => {
        console.log("Received message:", event.data);
        this.loadMyKadData(event);
      };

      this.socket.onclose = (event) => {
        console.log("WebSocket connection closed:", event);
      };

      this.socket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    } catch (e) {}
  }
  
  /**
   *
   *
   * @param {*} event
   * @memberof SamplePatientRegistrationComponent
   */
  loadMyKadData(event) {
    let myKadData: MyKadData = JSON.parse(event.data);
    // let myKadData: MyKadData = event;
    if (myKadData.Name) {
      const GenderCode = this.patientRegService.getCodeBySystemCode(
        this.genderList,
        myKadData.Gender ? myKadData.Gender : ""
      );

      const CountryCode = this.patientRegService.getCodeByStaticCode(
        this.countryPrimaryList,
        STATICCODESERVICE.COUNTRY_MALAYSIA ?
          STATICCODESERVICE.COUNTRY_MALAYSIA :
          "MYS"
      );

      const cardType = (myKadData.CardType && myKadData.CardType == STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD)
        ? STATICCODESERVICE.IDENTIFICATION_TYPE_MYKAD
        : STATICCODESERVICE.IDENTIFICATION_TYPE_MYKID

      const IdType = this.patientRegService.getCodeByStaticCode(
        this.identificationTypeList,
        cardType
      );

      const dob = moment(myKadData.BirthDate, "DD/MM/YYYY hh:mm:ss aa").format(
        "YYYY-MM-DD"
      );

      this.genderValue = GenderCode;
      this.countryValue = CountryCode;
      this.getStatePrimaryList(this.countryValue, true);

      this.formRegistration.patchValue({
        id: "",
        mrn: "",
        firstName: myKadData.Name,
        primaryId: IdType,
        expiryDate: "",
        primaryNumber: myKadData.ICNo,
        dateOfBirth: new Date(dob),
        gender: GenderCode,
        addressPrimary:
          myKadData.Address1 + " " + myKadData.Address2 + " " + myKadData.Address3,
        countryPrimary: CountryCode,
        cityPrimary: "",
        statePrimary: "",
        pincodePrimary: myKadData.Postcode,
        issuedCountryPrimary: CountryCode
      });

      setTimeout(() => {
        const StateCode = this.patientRegService.getCodeBySystemCode(
          this.statePrimaryList,
          myKadData.State ? myKadData.State : ""
        );

        this.stateValue = StateCode;
        this.formRegistration.patchValue({
          statePrimary: StateCode,
        });

        const State = this.patientRegService.getObjByCode(
          this.statePrimaryList,
          StateCode
        );
        this.getCityPrimaryList(State);

        setTimeout(() => {
          const CityCode = this.patientRegService.getCodeBySystemCode(
            this.cityPrimaryList,
            myKadData.City ? myKadData.City : ""
          );

          this.cityValue = CityCode;
          this.formRegistration.patchValue({
            cityPrimary: CityCode,
          });
        }, 1500);
      }, 1500);

      if (myKadData.PhotoBase64) this.patientImage = "data:image/jpeg;base64," + myKadData.PhotoBase64;
      else this.patientImage = "";

      this.primaryNumberOnKeyUp(myKadData.ICNo);
      this.formRegistration.updateValueAndValidity();
    }
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getMyKadMasters() {
    this.getIdentificationTypeMaster();
    this.getGenderMaster();
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getGenderMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_GENDER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.genderList = data;
      });
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getIdentificationTypeMaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.identificationTypeList = data;
      });
  }

  /**
   *Fill DropDown List
   *
   * @memberof SamplePatientRegistrationComponent
   */
  fillDropDownLists() {
    this.getPayerList();
    this.getPayerTypeList();
    this.getContractListData();
    this.getTariffmaster();
    this.getAssociatedCompanyList();
    this.getGLTypeList();
    this.getReasonList();
    this.getDoctorList(null);
    this.getdepartment();
    this.getCountryList();
    setTimeout(() => {
    this.getTariffList(0);
    }, 2000);
  }

  /**
   *getpatient search by id
   *
   * @param {*} patientId
   * @memberof SamplePatientRegistrationComponent
   */
  getpatientbyId(patientId) {
    let reqPayload =
      "identificationId=&name=&mrn=" +
      patientId +
      "&gender=&unitCode=&city=&identificationType=&frDate=&toDate=&id=&mobile=&birthDate=&offset=&size=&pincode=&country=&state=";
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_PATIENT_SEARCH + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any[]) => {
        let pateintData = this.patientDataService.displayList(res);
        this.getPatientData(pateintData[0]);
      });
  }

  /**
   *Destroy mehtod
   *
   * @memberof SamplePatientRegistrationComponent
   */
  ngOnDestroy() {
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
    this.socket.close();
  }

  /**
   *Search On changes
   *
   * @memberof SamplePatientRegistrationComponent
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.doctorSearch.valueChanges.subscribe((value) => {
        this.doctorFilteredList = this.docList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.formRegistration.controls["dateOfBirth"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
    this.subscriptionList.add(
      this.formEncounter.controls["visitToDepartment"].valueChanges.subscribe(
        (isVisitToDepartment) => {
          let doctorControl = this.formEncounter.controls["doctor"];
          this.formEncounter.controls["doctor"].setValue("");
          if (isVisitToDepartment) {
            doctorControl.clearValidators();
            this.isDepartment = false;
          } else {
            doctorControl.setValidators([Validators.required]);
            this.isDepartment = true;
          }
          doctorControl.updateValueAndValidity();
        }
      )
    );
    this.subscriptionList.add(
      this.payerTypeSearch.valueChanges.subscribe((value) => {
        this.payerTypeList = this.payerTypeFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.payerSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
        element.payerList = element.payerFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    })
    );
    this.subscriptionList.add(
      this.contractCodeSearch.valueChanges.subscribe((value) => {
        this.dataSourcePayers.data.forEach((element, index) => {
          element.contractList = element.contractCodeList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        });
      })
    );
    this.subscriptionList.add(
      this.associatedCompanySearch.valueChanges.subscribe((value) => {
        this.associatedCompanyList = this.associatedCompanyCodeList.filter(
          (i) => i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.tariffSearch.valueChanges.subscribe((value) => {
        this.tariffList = this.tariffFilteredList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    this.subscriptionList.add(
      this.dipartmentSearch.valueChanges.subscribe((value) => {
        this.departmentFilterList = this.departmentList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  /**
   *upload image
   *
   * @memberof SamplePatientRegistrationComponent
   */
  uploadImageDialog(): void {
    const dialogRef = this.dialog.open(CameraDialogComponent, {
      width: "400px",
      data: { name: "" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        try {
          if (result.res == "yes") {
            this.patientImage = result.picdata;
          } else {
            this.patientImage = "";
          }
        } catch (e) {}
      })
    );
  }

  /**
   *select patient Data
   *
   * @param {*} patient
   * @memberof SamplePatientRegistrationComponent
   */
  patientOnSelect(patient) {
    this.getPatientStatus(patient);
    this.checkPatientLastVisit(patient);
  }

  /**
   *
   *
   * @param {*} patient
   * @memberof SamplePatientRegistrationComponent
   */
  getPatientStatus(patient) {
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.PATIENT_STATUS_FILTER+ patient.id)
      .subscribe((res) => {
        this.admissionStatus=res.isAdmitted;
        if(res.isAdmitted==true){
          if(res.validationMsg){
            this.snackBar.open(
              this.langService.get("adt.Selectedpatient"),
              this.langService.get("dialogs.info"),
            { duration: 3000 });
          }
          this.formRegistration.reset();
          this.formEncounter.reset();
        }
        else{
          if (patient.id) {
            this.getPatientData(patient);
            this.isRegistered = true;
          }
        }
      });

  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getAppConfigList() {
    let mrdConfig: any;
    this.applicationConfig
    .getModuleConfiguration(MasterMenus.OPD, "")
    .subscribe((res) => {
        if (res) {
          mrdConfig = res;
          mrdConfig.forEach((element) => {
           
            if (element.key == MasterKeys.staffActiveFlag){
              if (element.valueList.length > 0) {
                this.isStaffActive = element.valueList[0].code=="true"?true:false;
              }
            }
          
          });
        }
      });
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getOrgAppConfigList(){
    let appConfig: any;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res) {
          appConfig = res.keys;
          appConfig.forEach((element) => {
            if (element.key == MasterKeys.primaryIdentification){
              if (element.valueList?.length > 0 && element.valueList[0]?.code) {
                  let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code);
                  this.formRegistration.controls["primaryId"].setValue(value?.code);  
                  this.cdr.detectChanges();
                  this.identificationList.data[0].idType=value?.code;
                  this.mandatoryField.identificationType=true;
                  this.mandatoryField.identificationNo=true;
                  this.primaryIdentificationOnChange(value,false);
            }
          }
            if (element.key == MasterKeys.firstPayerPriorityRequired){
              if (element.valueList.length > 0) {
                this.isFirstPayerPriority = element.valueList[0].code=="true"?true:false;
              }
            }
            if (element.key == MasterKeys.isDefaultDepositRequired){
              if (element.valueList.length > 0) {
                this.isDefaultDeposit = element.valueList[0].code=="true"?true:false;
              }
            }
          });
        }
      });
  }

  /**
   *check patient last visit occurred over 3 months ago
   *
   * @param {*} patient
   * @memberof SamplePatientRegistrationComponent
   */ 
  checkPatientLastVisit(patient){
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.CHECK_PATIENT_LAST_VISIT + patient.mrn)
      .subscribe((res) => {
        if(res.message!=null){
          setTimeout(() => {
            this.snackBar.open(res.message,"Validation",{duration:3000})
          }, 3000);
        }
      });

      if(patient.expiryDate ){
        const existingDate = new Date(patient.expiryDate);
        const currentDate = new Date();
        if (existingDate < currentDate) {
        this.snackBar.open(
          this.langService.get("RegistrationPage.expiryDateValidationMessage"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 4000,
          });
        
          setTimeout(() => {
            for (var i in this.formRegistration.controls) {
              this.formRegistration.controls[i].markAsTouched();
            }
          }, 3000);
        }
      }
      if(this.isStaffActive){
        if(!patient.isStaffActive && patient.secondaryIdType && patient.isStaffActive!=undefined){
        this.snackBar.open(
          this.langService.get("RegistrationPage.activeStaffValidationMessage"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 4000,
          });
          this.isSave = false;
      }
      else{
        this.isSave = true;
      }
    }
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  // getTariffList(i?) {
  //   if (this.isPatientCategory) {
  //     let payload = null;
  //     if (this.selectedPatient && this.selectedPatient.patientCategory) {
  //       payload = this.selectedPatient.patientCategory || null;
  //     } else if (this.formEncounter.controls["patientCategory"].value && this.formEncounter.controls["patientCategory"].value.code) {
  //       payload = this.formEncounter.controls["patientCategory"].value.code || null;
  //     }
  //     if (payload) {
  //       this.masterApiService
  //         .getTypeMaster(OPD_API_URL.PATIENT_CATEGORY_MASTER + payload)
  //         .pipe(takeUntil(this._onDestroy))
  //         .subscribe((res: any) => {

  //           this.tariffList = res?.payload?.patientCategoryDTOResponse?.tariffResponseList || [];
  //           const list = this.tariffList.filter(i => i.isDefault);
  //           this.tariffFilteredList = this.tariffList;

  //           if(this.dataSourcePayers.data.length>0){
  //             if(!this.dataSourcePayers.data[0].tariffCode){
  //             this.dataSourcePayers.data[0].tariffCode = list[0].code;
  //         }
  //       }
  //       let contractTariff = this.tariffFilteredList.find(i=>i.code ==this.contractValue?.tariffMaster?.code)
  //       if(contractTariff){
  //         this.dataSourcePayers.data[i].tariffCode = contractTariff?.code;
  //         } 
  //     });
  //    }
  //   }
  //    let contractTariff = this.tariffList.find(i=>i.code ==this.contractValue?.tariffMaster?.code)
  //     if(contractTariff){
  //       this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //   }
  // }
  // getTariffList(i?) {
  //   if (this.selectedPatient.patientCategory) {
  //     let payload = this.selectedPatient.patientCategory || null;
  //     this.masterApiService
  //       .getTypeMaster(OPD_API_URL.PATIENT_CATEGORY_MASTER + payload)
  //       .pipe(takeUntil(this._onDestroy))
  //       .subscribe((res: any) => {
  //         if (this.isPatientCategory) {
  //         if (res.payload.patientCategoryDTOResponse && res.payload.patientCategoryDTOResponse.tariffResponseList) {
  //           if(this.isCompany == true){
  //           this.dataSourcePayers.data[i].tariffList = this.tariffCompanyList;
  //           this.dataSourcePayers.data[i].tariffFilteredList =   this.dataSourcePayers.data[i].tariffList;
  //             this.defaultTariff =  this.dataSourcePayers.data[i].tariffList.find(i => i.isDefault === true);
  //            }  else{
  //             this.dataSourcePayers.data[0].tariffList = res.payload?.patientCategoryDTOResponse?.tariffResponseList;
  //             this.tariffFilteredList=this.tariffList;
  //              this.defaultTariff =  this.dataSourcePayers.data[0].tariffList.find(i => i.isDefault === true);
  //          }
  //         }
  //         if (i === undefined) {
  //           if (this.dataSourcePayers.data.length > 0 && this.isPatientCategory) {
  //             this.dataSourcePayers.data[0].tariffCode = this.defaultTariff ? this.defaultTariff.code : null;
  //           }
  //         } else {
  //           if(this.isContract == true){
  //             this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //           let contractTariff = this.dataSourcePayers.data[i].tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //           if (contractTariff) {
  //             this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //             this.dataSourcePayers.data[i].isDisableTariff = true;
  //           }else{
  //             this.dataSourcePayers.data[i].isDisableTariff = false;
  //           }
  //           }else{
  //             if(this.tariffCompanyList && this.tariffCompanyList.length > 0){
  //               this.dataSourcePayers.data[i].tariffList = this.isCompany  ? this.tariffCompanyList : res.payload?.patientCategoryDTOResponse?.tariffResponseList;
  //            }else{
  //             this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //            }
  //           }
  //         }
  //       }else {
  //         if (res.payload.patientCategoryDTOResponse && res.payload.patientCategoryDTOResponse.tariffResponseList) {
  //           if(this.isCompany == true){
  //           this.dataSourcePayers.data[i].tariffList = this.isCompany  ? this.tariffCompanyList : res.payload.patientCategoryDTOResponse.tariffResponseList;
  //           this.dataSourcePayers.data[i].tariffFilteredList =   this.dataSourcePayers.data[i].tariffList;
  //           this.defaultTariff =  this.dataSourcePayers.data[0].tariffList.find(i => i.isDefault === true);
  //           } else{
  //             this.dataSourcePayers.data[0].tariffList = res.payload.patientCategoryDTOResponse.tariffResponseList;
  //           this.tariffFilteredList=this.tariffList;
  //           this.defaultTariff =  this.dataSourcePayers.data[0].tariffList.find(i => i.isDefault === true);
  //          }
  //         }  
  //         if (i === undefined) {
  //           if (this.dataSourcePayers.data.length > 0 && !this.isPatientCategory) {
  //             this.dataSourcePayers.data[0].tariffCode = this.defaultTariff ? this.defaultTariff.code : null;
  //           }
  //         } else {
  //           if(this.isContract == true){
  //             this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //           let contractTariff = this.dataSourcePayers.data[i].tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //           if (contractTariff) {
  //             this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //             this.dataSourcePayers.data[i].isDisableTariff = true;
  //           }else{
  //             this.dataSourcePayers.data[i].isDisableTariff = false;
  //           }
  //           }else{
  //             if(this.tariffCompanyList && this.tariffCompanyList.length > 0){
  //               this.dataSourcePayers.data[i].tariffList = this.isCompany  ? this.tariffCompanyList : res.payload?.patientCategoryDTOResponse?.tariffResponseList;
  //               this.dataSourcePayers.data[i].tariffCode = this.dataSourcePayers.data[i].tariffList[0].code;
  //               this.dataSourcePayers.data[i].isDisableTariff = true;
  //              }else{
  //              this.dataSourcePayers.data[i].tariffList = this.tariffList;
  //             }
  //           }
  //         }
  //         }
  //       });
  //       }    else {
  //         let contractTariff = this.tariffList.find(i => i.code === this.contractValue?.tariffMaster?.code);
  //         if (contractTariff) {
  //           this.dataSourcePayers.data[i].tariffCode = contractTariff.code;
  //         }
  //       }
  //    }

    getTariffList(i?) {
      let patientCategory=this.formEncounter.controls["patientCategory"]?.value;
      this.dataSourcePayers.data.forEach((payer, index) => {
        if (i === index) {
          this.masterApiService
          .getTypeMaster(OPD_API_URL.GET_TARIFF_LIST+"patientCategoryCode="+patientCategory.code+"&companyCode="+payer.payerCode+"&isPatientCategory="+this.isPatientCategory )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res: any) => {
            if(res.payload && res.payload.length > 0){
              this.dataSourcePayers.data[i].tariffList = res.payload;
              this.dataSourcePayers.data[i].tariffFilteredList=res.payload;
              this.dataSourcePayers.data[i].tariffCode =res.payload[0]?.code;
            }else{
              this.dataSourcePayers.data[i].tariffList = [];
              this.dataSourcePayers.data[i].tariffFilteredList=[];
              this.dataSourcePayers.data[i].tariffCode =null;
            }
          })
        }
      });
    }
  /**
   *get patient data   
   *
   * @param {*} patient
   * @memberof PatientRegistrationComponent
   */
  getPatientData(patient) {    
    this.identificationList=new MatTableDataSource<Identification>([]); 
    if (patient.ctos || patient.blocked || patient.deceased || patient.merged || patient.isInactive) {
      const dialogRef = this.dialog.open(InfoDialogComponent, {

        data: {
          display:
            patient.mrn +
            " / " +
            patient.fullName +
            " / " +
            (patient.gender ? patient.gender : "Unknown") +
            " / " +
            (patient.dateOfBirth ? patient.dateOfBirth : ""),
          info: patient.deceased
            ? this.langService.get("EncounterPage.unabletoProceedDecease")
            : patient.merged
            ? this.langService.get("EncounterPage.unabletoProceedMerge")
            : patient.blocked
            ? this.langService.get("EncounterPage.selectPatientBlock")
            :this.langService.get("EncounterPage.selectPatientInactive")
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (
            result != undefined &&
            result.confirm &&
            result.confirm == "yes"
          ) {
            this.clearAllPatientEncounter();
          } else {
            this.clearAllPatientEncounter();
          }
        })
      );
    } else {
      this.isVip = patient.vip;
      this.isVip == true ?  this.isDisabled = true : this.isDisabled = false;
      this.isNoteVisible = patient.patientNotes ? patient.patientNotes :"";
      this.getAppointmentCheck(patient.mrn);
      this.getPreviousEncounters(patient.mrn);
      this.selectedPatient = patient;

      this.genderValue = this.selectedPatient
        ? this.selectedPatient.gender
        : "";
          this.defaultGender = this.genderList.find((i) => i.desc ==   this.genderValue );
      this.identifierTypeValue = this.selectedPatient
        ? this.selectedPatient.identifierType
        : "";
      this.titleValue = this.selectedPatient ? this.selectedPatient.title : "";
      this.countryValue = this.selectedPatient
        ? this.selectedPatient.extendedAddress
          ? this.selectedPatient.extendedAddress.country
          : null
        : null;
      this.selectedPrimaryId = this.selectedPatient ? this.selectedPatient.idNo : "";

      // this.getDocuments(patient.mrn);
      this.getPreviousPayerList(patient.mrn);
      var dobFormatted = "";
      var patientAge = undefined;
      if (patient.dateOfBirth) {
        dobFormatted =  patient.dateOfBirth
        ? (this.langaugeValue == Langauge.TH
          ? this.thConvertService.convertThaiDateString(patient.dateOfBirth)
          : this.datepipe.transform(patient.dateOfBirth, "dd-MM-yyyy"))
        : null;
        let dobDate = new Date(patient.dateOfBirth);
        patientAge = this.utilsService.getAge(dobDate);
        patientAge =
          patientAge > 1
            ? "(" + patientAge + " Years)"
            : "(" + patientAge + " Year)";
      }
      this.patientInfoDisplay =
        patient.mrn +
        " / " +
        patient.fullName +
        " / " +
        (patient.gender ? patient.gender : "Unknown") +
        " / " +
        (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");

        let photo=  patient.photo ? patient.photo : "";
        if( photo && photo.includes("doc-service"))
           photo=this.imageUrl+ photo;
      this.patientImage = photo;
      this.formRegistration.enable();
      this.patientId = patient.id;
      if (patient.patientNotes)
        this.formEncounter.controls["reportRemarks"].setValue(
          patient.patientNotes
        );
        this.isPrimaryNoEditable=patient.identifierType?true:false;
      this.formRegistration.patchValue({
        id: patient.id,
        mrn: patient.mrn,
        primaryNumber: patient.idNo,
        primaryId: patient.identifierType ? patient.identifierType : "",
        expiryDate: patient.expiryDate ? new Date(patient.expiryDate) : "",
        issuedCountryPrimary: patient.idIssueCountry
          ? patient.idIssueCountry
          : "",
        secondaryId: patient.secondaryIdType ? patient.secondaryIdType : "",
        secondaryNumber: patient.secondaryNo,
        issuedCountrySecondary: "",
        firstName: patient.fullName,
        // aliasName: patient.aliasName ? patient.aliasName : "",


        dateOfBirth: patient.dateOfBirth ? new Date(patient.dateOfBirth) : "",
        birthTime: patient.birthTime ? patient.birthTime : "",
        realdob: patient.real ? patient.real : false,
        birthplace: patient.birthlocation ? patient.birthlocation : "",
        motherName: patient.motherName ? patient.motherName : "",
        patientNotes: patient.patientNotes ? patient.patientNotes : "",
        addressPrimary: patient.extendedAddress
          ? patient.extendedAddress.addressLine
          : "",

        cityPrimary:
          patient.extendedAddress && patient.extendedAddress.city
            ? patient.extendedAddress.city
            : "",
        subDistrictPrimary:
          patient.extendedAddress && patient.extendedAddress.area
            ? patient.extendedAddress.area
            : "",
        pincodePrimary: patient.extendedAddress
          ? patient.extendedAddress.postCode
          : "",
        emailId: patient.emailId,
        homeContact: patient.homeContactNo,
        mobileNumber: patient.mobileNumber,
        addressSecondary: patient.correspondingAddress
          ? patient.correspondingAddress.addressLine
          : "",

        pincodeSecondary: patient.correspondingAddress
          ? patient.correspondingAddress.postCode
          : "",
        workContact: patient.workContactNo,
        contactRelation: patient.relation ? patient.relation : "",
        isDeceased: patient.deceased ? patient.deceased : "",
        isBlocked: patient.blocked ? patient.blocked : "",
        isVip: patient.vip ? patient.vip : false,
        isNewborn: patient.newBorn ? patient.newBorn : false,
        workFax: patient.workFax ? patient.workFax : "",
        personalFax: patient.personalFax ? patient.personalFax : "",
        secondaryExpirydate: patient.seondaryExpiryDate
          ? new Date(patient.seondaryExpiryDate)
          : "",
      });

      // let primaryIdValue = this.primaryIdFilteredList.find(e=>e.desc==patient.identifierType);
      // if(primaryIdValue.isMyKad) this.primaryNumberOnKeyUp(patient.idNo);
      if (patient.primaryIdentificationList.length>0 || patient.secondaryIdentificationList.length>0) {
        const tempData: any[] = [];
        // Handle Primary Identification
        patient.primaryIdentificationList?.forEach((element) => {
          const idTypeCode = this.getObjByCode(this.primaryIdFilteredList, element.code);
          const data = {
            identifierUUID: element.identifierUUID || '',
            type: 'P',
            idType: element.code,
            idNumber: element.value?element.value:"",
            expDate: element.expiryDate,
            primaryIdRegex: OPD_CONST.primaryIdRegix,
            isExpiryRequired: element.display === "Passport",
            issuingCountry: element.issuingCountryCode || '',
            isCopied: element.status === false,
            isIdNumberValid:element.value.length>0?true:false,
            isCountryRequired:false
          };
      
          if (element.status) {
            this.identificationList.data.push(data);
            const newIndex = this.identificationList.data.length - 1;
            this.primaryIdentificationOnChange(idTypeCode, false, newIndex);
          } else {
            tempData.unshift(data); 
          }
        });
      
        // Handle Secondary Identification
        patient.secondaryIdentificationList?.forEach((element) => {
          if (element.status) {
            const data = {
              identifierUUID: element.identifierUUID || '',
              type: 'S',
              idType: element.code,
               idNumber: element.value?element.value:"",
              expDate: element.expiryDate,
              issuingCountry: element.issuingCountryCode || '',
              primaryIdRegex: OPD_CONST.primaryIdRegix,
              isExpiryRequired: false,
              isIdNumberValid:element.value.length>0?true:false,
              isCountryRequired:false
            };
            this.identificationList.data.push(data);
          }
        });
      
        const sorted = this.identificationList.data
          .filter(d => !d.isCopied)
          .concat(tempData);
        this.identificationList.data = [...sorted];
      
      } else {
        this.addEmptyIdentificationEntry("P");
      }
      
      this.selectedPatientIdentificationList = JSON.parse(JSON.stringify(this.identificationList.data));


      this.countrySecondaryValue = patient.correspondingAddress.country;
      this.getStatePrimaryList(
        patient.correspondingAddress && patient.correspondingAddress.country != ""
          ? patient.correspondingAddress.country
          : patient.extendedAddress.country,
        true
      );
      this.getStateSecondaryList(
        patient.correspondingAddress && patient.correspondingAddress.country
          ? patient.correspondingAddress.country
          : "",
        true
      );

      if (
        patient.extendedAddress.addressLine ==
          patient.correspondingAddress.addressLine &&
        patient.extendedAddress.postCode ==
          patient.correspondingAddress.postCode
      ) {
        this.isBothAddressSame = true;
      }
    }
  }

  /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof SamplePatientRegistrationComponent
   */
  getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.statePrimaryList = res;
          if (this.selectedPatient) {
            const stateres = this.statePrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.state
                  : "")
            );
            this.stateValue = stateres ? stateres.code : "";
            this.getCityPrimaryList(stateres);
          }
        });
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof SamplePatientRegistrationComponent
   */
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.cityPrimaryList = res;
          if (this.selectedPatient) {
            const cityres = this.cityPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.city
                  : "")
            );
            this.cityValue = cityres ? cityres.code : "";
            this.getSubDistrictPrimaryList(cityres);
          }
        });
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };

      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictPrimaryList = res;
          if (this.selectedPatient) {
            const distres = this.subDistrictPrimaryList.find(
              (i) =>
                i.code ==
                (this.selectedPatient.extendedAddress
                  ? this.selectedPatient.extendedAddress.area
                  : "")
            );
            this.districtValue = distres ? distres.code : "";
          }
        });
    }
  }

  /**
   *Passing countryCode to get the stateSecondaryList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getStateSecondaryList(countryCode, isCode) {
    if (countryCode) {
      if (this.isSameAddress) {
        this.stateSecondaryValue =
          this.formRegistration.controls["statePrimary"].value.code;
      } else if (this.selectedPatient) {
        this.stateSecondaryValue = this.selectedPatient.correspondingAddress
          ? this.selectedPatient.correspondingAddress.state
          : "";
      }
      let result: any = "";
      if (isCode)
        result = this.countrySecondaryList.find((i) => i.code == countryCode);
      else
        result = this.countrySecondaryList.find(
          (i) => i.code == countryCode.code
        );
      this.secondaryCountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.stateSecondaryList = res;
          const stateres = this.stateSecondaryList.find(
            (i) => i.code == this.stateSecondaryValue
          );

          this.getCitySecondaryList(stateres);
        });
    }
  }

  /**
   *Passing stateCode to get the citySeocndaryList
   *
   * @param {*} cityCode
   * @memberof SamplePatientRegistrationComponent
   */
  getCitySecondaryList(stateCode) {
    if (stateCode) {
      if (this.isSameAddress) {
        this.citySecondaryValue =
          this.formRegistration.controls["cityPrimary"].value.code;
      } else if (this.selectedPatient) {
        this.citySecondaryValue = this.selectedPatient.correspondingAddress
          ? this.selectedPatient.correspondingAddress.city
          : "";
      }
      const result = this.stateSecondaryList.find(
        (i) => i.code == stateCode.code
      );
      this.secondaryStateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.citySecondaryList = res;
          const cityres = this.citySecondaryList.find(
            (i) => i.code == this.citySecondaryValue
          );

          this.getSubDistrictSecondaryList(cityres);
        });
    }
  }

  /**
   *Passing cityCode to get the subDistrictSecondaryList
   *
   * @param {*} cityCode
   * @memberof SamplePatientRegistrationComponent
   */
  getSubDistrictSecondaryList(cityCode) {
    if (cityCode) {
      const result = this.citySecondaryList.find(
        (i) => i.code == cityCode.code
      );
      this.secondaryDistrictCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
      this.masterApiService
        .getTypeMaster(
          OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          this.subDistrictSecondaryList = res;
        });
    }
    if (this.isSameAddress)
      this.districtSeoncdaryValue =
        this.formRegistration.controls["subDistrictPrimary"].value.code;
    else if (this.selectedPatient)
      this.districtSeoncdaryValue = this.selectedPatient.correspondingAddress
        ? this.selectedPatient.correspondingAddress.area
        : "";
  }

  /**
   *temporary patient details
   *
   * @param {string} trnNumber
   * @memberof PatientRegistrationComponent
   */
  getTemporaryPatient(trnNumber: string) {
    this.patientForm = true;
    this.patientTRN = trnNumber;

    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + trnNumber
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res) {
          this.patientInfoDisplay = "";
          this.patientInfoDisplay =
            res.trn +
            " / " +
            res.patientName +
            " / " +
            (res.genderList ? res.genderList[0].display : "Unknown");
          this.selectedPatient = null;
          (this.identifierTypeValue = res.primaryIdentificationType
            ? res.primaryIdentificationType[0].code
            : ""),
            (this.titleValue = res.prefixList ? res.prefixList[0].code : ""),
            (this.genderValue = res.genderList ? res.genderList[0].code : ""),
            (this.countryValue =
              res.extendedAddress && res.extendedAddress.countryList
                ? res.extendedAddress.countryList[0].code
                : ""),
            this.getStatePrimaryList(this.countryValue, true);
            this.getPreviousPayerList(res.trn);
          this.formRegistration.patchValue({
            prefix: res.prefixList ? res.prefixList[0].code : "",
            emailId: res.email,
            firstName: res.patientName,
            dateOfBirth: res.dob,
            mobileNumber: res.mobileNo,
            homeContact: res.homeNo,
            workContact: res.officeNo,
            primaryNumber: res.idNumber,
            expiryDate: res.idExpiry ? new Date(res.idExpiry) : "",
            addressPrimary: res.extendedAddress
              ? res.extendedAddress.addressLine
              : "",

            countryPrimary:
              res.extendedAddress && res.extendedAddress.countryList
                ? res.extendedAddress.countryList[0].code
                : "",
            statePrimary:
              res.extendedAddress && res.extendedAddress.stateList
                ? res.extendedAddress.stateList[0].code
                : "",
            cityPrimary:
              res.extendedAddress && res.extendedAddress.cityList
                ? res.extendedAddress.cityList[0].code
                : "",
            subDistrictPrimary:
              res.extendedAddress && res.extendedAddress.areaList
                ? res.extendedAddress.areaList[0].code
                : "",
            pincodePrimary: res.extendedAddress
              ? res.extendedAddress.postCode
              : "",
          });
        }
      });
  }

  /**
   *get documents using MRN
   *
   * @param {*} mrn
   * @memberof SamplePatientRegistrationComponent
  //  */
  // getDocuments(mrn) {
  //   this.fileUploadRegList = [];
  //   this.appBaseService.setResourceURL(OPD_API_URL.FILE_SERVICE);
  //   this.appBaseService
  //     .getFileResource(OPD_API_URL.OPD_FILE_GET + "?mrn=" + mrn)
  //     .pipe(takeUntil(this._onDestroy))
  //     .subscribe((res) => {
  //       if (res.payload) {
  //         res.payload.forEach((element) => {
  //           if (element.visitNo == null || element.visitNo == "") {
  //             let docType = this.docTypeFilteredList.find((data) => {
  //               return data.code == element.documentTypeMaster.code;
  //             });
  //             this.fileUploadRegList.push({
  //               id: element.id,
  //               fileType: docType.code,
  //               fileName: element.fileName,
  //               files: element.data,
  //               fileDescription: element.fileDescription,
  //               mrn: element.mrn,
  //               isUploaded: true,
  //             });
  //           }
  //         });
  //       }

  //       this.fileSourceReg = new MatTableDataSource(this.fileUploadRegList);
  //     });
  // }

  /**
   *validate doctor
   *
   * @memberof SamplePatientRegistrationComponent
   */
  validationOnDoctor() {
    let departmentCode = this.formEncounter.controls["department"].value;
    let doctorCode = this.formEncounter.controls["doctor"].value;
    if (this.patientId && departmentCode) {
      this.generalApiService
        .getTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.OPD_DUPLICATE_ENCOUNTER +
            departmentCode.code +
            "&doctorCode=" +
            doctorCode +
            "&patientId=" +
            this.patientId
        )
        .pipe(takeUntil(this._onDestroy))
        .subscribe((response: any) => {
          if (response) {
            this.snackBar.open(
              this.langService.get("CommonAppoinment.warning"),
              this.langService.get("CommonAppoinment.duplicateEncouter") + "",
              {
                duration: 5000,
              }
            );
          }
        });
    }
  }

  /**
   *get previous encounters data
   *
   * @param {*} patientMrn
   * @memberof SamplePatientRegistrationComponent
   */
   getAppointmentCheck(patientMrn){
    this.generalApiService
    .getTypeApi(
      OPD_API_URL.OPD_SERVICE,
      OPD_API_URL.GET_APPOINTMENT_CHECK + patientMrn
    )
    .pipe(takeUntil(this._onDestroy))
    .subscribe((res: any) => {
     if(res.payload){   
      const dialogRef = this.dialog.open(EncounterAppointmnetComponent, {
         width: "990px",
      height: "230px",
      data: res,
     });
     this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(result.appointmentType.code == OPD_CONST.aptref.apttypeDeptCode){
          this.formEncounter.patchValue({
            visitToDepartment: true,
          });
          this.isFromAppointment = true
        this.appointmentReference.appointmentNo = result.appointmentNo;
        this.appointmentReference.appointmentId = result.appointmentId;
        this.appointmentReference.departmentCode = result.speciality ? result.speciality.code :"";
        this.appointmentReference.appointmentDate = result.appointmentDetails;
        this.appointmentReference.doctorCode = result.doctor ? result.doctor.code:"";
        // this.appointmentReference.bookingType = result.appointmentType.id;
        if(result.speciality){
        this.departmentValue=this.departmentList.find(e=>e.code===result.speciality.code);
        this.formEncounter.controls["department"].markAsTouched();
        }
        this.formEncounter.controls["doctor"].markAsTouched();
        }else if(result.appointmentType.code == OPD_CONST.aptref.apttTypeHscCode){
          this.formEncounter.patchValue({
            visitToDepartment: true,
          });
          this.isFromAppointment = true
        this.appointmentReference.appointmentNo = result.appointmentNo;
        this.appointmentReference.appointmentId = result.appointmentId;
        this.appointmentReference.departmentCode = result.speciality ? result.speciality.code :"";
        this.appointmentReference.appointmentDate = result.appointmentDetails;
        this.appointmentReference.doctorCode = result.doctor ? result.doctor.code:"";
        // this.appointmentReference.bookingType = result.appointmentType.id;
        if(result.speciality){
        this.departmentValue=this.departmentList.find(e=>e.code===result.speciality.code);
        this.formEncounter.controls["department"].markAsTouched();
        }
       
        this.formEncounter.controls["doctor"].markAsTouched();
         } else{
        this.formEncounter.patchValue({
        visitToDepartment: false,
        });
        this.isFromAppointment = false
        this.appointmentReference.appointmentNo = result.appointmentNo;
        this.appointmentReference.appointmentId = result.appointmentId;
        this.appointmentReference.departmentCode = result.speciality ? result.speciality.code :"";
        this.appointmentReference.appointmentDate = result.appointmentDetails;
        this.appointmentReference.doctorCode = result.doctor ? result.doctor.code:"";
        // this.appointmentReference.bookingType = result.appointmentType.id;
        if(result.speciality){
        this.departmentValue=this.departmentList.find(e=>e.code===result.speciality.code);
        this.formEncounter.controls["department"].markAsTouched();
        }
       
        this.formEncounter.controls["doctor"].setValue(result.doctor.code);
      }
      }
      })
      );
    }
    })
   }
  getPreviousEncounters(patientMrn) {
    let list = [];
    this.formEncounter.reset();
    let reqPayload = patientMrn + OPD_API_URL.OPD_PREVIOUS_ENCOUNTERS;
    if (this.isPatientCategory) {
      this.formEncounter.get("patientCategory").disable();
    } else {
      this.formEncounter.get("patientCategory").enable();
    }
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_ENCOUNTER_LIST + reqPayload
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        res.totalRecords > 0 ? this.pdpaForm = true : this.pdpaForm = false
        if (res && res.totalRecords > 0) {
          res.response.forEach((element, index) => {
            this.patientImage = element.patient
              ? element.patient[0]
                ? element.patient[0].photo[0].url
                : ""
              : "";
            var utcSeconds = element.createdDate;
            var encounterDate = new Date(0);
            this.previousInternalNotes = element.internalNoteList;
            this.internotesEncounterid = element.id;
            list.push({
              EncounterId: element.id,
              VisitDate: utcSeconds
              ? (this.langaugeValue == Langauge.TH
                ? this.thConvertService.convertToThaiDate(utcSeconds) :  this.datepipe.transform(utcSeconds*1000, "dd/MM/yyy hh:mm aa")): null,
              VisitNumber: element.encounterNumber,
              visitType:
                element.visitType && element.visitType.display
                  ? element.visitType.display
                  : "",
              Department: element.department ? element.department.display : "",
              DoctorName: element.doctor ? element.doctor.display : "",
              OutstandingAmount: "0.00",
              BillNumber: "",
              BillAmount: element.billAmount ? element.billAmount : "0.00",
              payer: element.payer ? element.payer : ""
            });
            // if (index == res.totalRecords - 1) {
            //   this.encounterTypeValue = element.encounterType
            //     ? element.encounterType.code
            //     : "";
            //   this.departmentValue = element.department
            //     ? element.department.code
            //     : "";
            //   this.doctorValue = element.doctor ? element.doctor.code : "";
            //   this.getDoctorList(element.department);
            // }
          });
        }
        this.previousEncounterList = list;
        this.dataSourceEncounters = new MatTableDataSource<any>(list);
        this.getTariffList(0);
      });
  }

  /**
   *get list data by code
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof SamplePatientRegistrationComponent
   */
  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }

  /**
   *confirm window
   *
   * @memberof SamplePatientRegistrationComponent
   */
  confirmClearPatientEncounter() {
    const dialogRefConfirm = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { confirm: "no" },
    });
    this.subscriptionList.add(
      dialogRefConfirm.afterClosed().subscribe((result) => {
        if (result.confirm == "yes") {
          this.clearAllPatientEncounter();
        }
      })
    );
  }

  /**
   *validate registration
   *
   * @return {*}  {boolean}
   * @memberof SamplePatientRegistrationComponent
   */
  validateRegistration(): boolean {
    if (this.isDeceased) {
      return this.formRegistration.valid;
    } else {
      for (var i in this.formRegistration.controls) {
        this.formRegistration.controls[i].markAsTouched();
      }
      for (var i in this.formEncounter.controls) {
        this.formEncounter.controls[i].markAsTouched();
      }
      if (!this.formRegistration.valid || !this.formEncounter.valid) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleasefillallmandatory"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 1000,
          }
        );
      }else{
        return this.formRegistration.valid;
      }
      if (this.mandatoryField.identificationType || this.mandatoryField.identificationNo) {
        for (const element of this.identificationList.data ) {
          if (element.type === "P" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid)) {
            this.snackBar.open("Please check Primary Identification Details", "Validation", { duration: 2000 });
            return false;
          }
        }
      }
      if (this.mandatoryField.secIdentificationType || this.mandatoryField.secIdentificationNo) {
        for (const element of this.identificationList.data) {
        if (element.type === "S" && (!element.idType || !element.idNumber.replace(/-/g, '') || !element.isIdNumberValid)) {
          this.snackBar.open("Please check Secondary Identification Details", "Validation", { duration: 2000 });
          return false;
        }
        }
      }
    }
  }

  /**
   *Validation encounter
   *
   * @return {*}  {boolean}
   * @memberof SamplePatientRegistrationComponent
   */
  validateEncounter(): boolean {
    let valid = true;
    let payersList = this.dataSourcePayers.data;
    if (payersList.length > 0) {
      payersList.forEach((element) => {
        console.log(element.payerCode);
        if (element.payerCode == "" || element.payerCode == undefined) {
          valid = false;
          this.snackBar.open(
            this.langService.get("EncounterPage.pleaseselectreferrconpamy"),
            this.langService.get("CommonAppoinment.validation"),
            {
              duration: 3000,
            }
          );
        }
        if (payersList.length > 0) {
          payersList.forEach((element) => {
            if (element.tariffCode == "" || element.tariffCode == undefined) {
              valid = false;
              this.snackBar.open(
                this.langService.get("CommonAppoinment.PleaseSelectTariff"),
                this.langService.get("CommonAppoinment.validation"),
                {
                  duration: 1000,
                }
              );
            }
          });
        }
      });
    }
    return valid;
  }

  /**
   *patient search
   *
   * @memberof PatientRegistrationComponent
   */
  public initSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.M_PAT_REG_SEARCH)
        .subscribe((data: any) => {
          this.searchHead.updateSearchHeader(data);
        })
    );

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.searchCriteria.isTodaysDate = true;
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(
      (quickSearch) => {
        let result = { mrn: quickSearch };
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      }
    );
    this.subscriptionList.add(quickSearch);
  }

  /**
   *save encounter
   *
   * @memberof SamplePatientRegistrationComponent
   */
   saveEncouter() {
    if (this.validateRegistration() && this.validateEncounter()) {
      if(this.formRegistration.controls["isVip"].value) {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "15%",
          data: { displayText: "conformVipMessage"},
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.confirm == "yes") {
              this.openRegisterConfirmationDialog();
            }
          })
        );
      } else {
        this.openRegisterConfirmationDialog();
      } 
    }
 }

  openRegisterConfirmationDialog(): void {
    const dialogRef = this.dialog.open(RegsuccessDialogComponent, {
      width: "20%",
      data: {},
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.workflow == "yes") {
          this.openEncounterConfirmDialog();
        }
      })
    );
  }

  /**
   *save patient and encounter
   *
   * @memberof SamplePatientRegistrationComponent
   */
  openEncounterConfirmDialog() {
    let patient: PatientRegistration =
      this.patientRegService.getRegistrationFormValues(
        this,
        this.formRegistration
      );

    let encounter = this.patientRegService.getEncounterFormValues(
      this,
      this.formEncounter
    );
    encounter.defaultDeposit = this.defaultDeposit;
    let dataSourcePayers = this.patientRegService.getEncounterPayerFormValues(
      this,
      this.dataSourcePayers
    );

    let requestPatientPayload = this.patientRegService.setSavePayload(
      this,
      patient
    );
    let requestEncounterPayload = this.patientRegService.setEncounterSave(
      this,
      encounter,
      dataSourcePayers,
      null
    );
    let requestObject = {
      patientRequest: requestPatientPayload,
      encounterRequest: requestEncounterPayload,
    };
    this.subscriptionList.add(
      this.generalApiService
        .postTypeApi(
          OPD_API_URL.OPD_SERVICE,
          OPD_API_URL.S_QUICK_PATIENT_ENCOUNTER,
          requestObject
        )
        .subscribe((response: any) => {
          if (response && response.id) {
            let encounterNumber = response.encounterNumber
              ? response.encounterNumber
              : response.identifier[0]
              ? response.identifier[0].value
              : "";

            this.snackBar.open(
              this.langService.get("EncounterPage.encounterHeader") +
                ": " +
                encounterNumber +
                " " +
                this.langService.get("EncounterPage.patientSaved"),
              this.langService.get("CommonAppoinment.success"),
              {
                duration: 1000,
              }
            );
            let visitNo=response?.identifier[0]?.value;
            if (!this.pdpaForm) {
              this.patientLableService.generateReports(response.id,OPD_REPORT_NAME.patient_Label);
              this.pdpaFormService.generateReports(response.id,OPD_REPORT_NAME.pdpaForm_new);
              this.encounterSlipService.generateReports(response.id,OPD_REPORT_NAME.encounter_Slip);
            }else{
            this.patientLableService.generateReports(response.id,OPD_REPORT_NAME.patient_Label);
            this.encounterSlipService.generateReports(response.id,OPD_REPORT_NAME.encounter_Slip);
            }

            this.encounternumber = response.encounterNumber;
            this.previousInternalNotes = [];
            this.internalNotesList = [];
        
            this.clearAllPatientEncounter();
          }
        })
    );
  }

  /**
   *mobile format
   *
   * @param {string} value
   * @param {string} name
   * @memberof SamplePatientRegistrationComponent
   */
  mobileFormat(value: string, name: string) {
    var r = /(\D+)/g,
      npa = "",
      last4 = "";
    value = value.replace(r, "");
    npa = value.substr(0, 3);
    last4 = value.substr(3, 10);
    value = npa + "-" + last4;
    if (value.replace("-", "").trim() == "") value = "";
    if (name == "mobile") {
      this.formRegistration.controls["mobileNumber"].setValue(value);
    }
  }

  /**
   *clear allthe data
   *
   * @memberof SamplePatientRegistrationComponent
   */
  clearAllPatientEncounter() {
    this.isOtherReferral = false; 
    this.othersReferral = '';
    localStorage.removeItem("appointmentData");
    localStorage.removeItem("admissionRequest");
    this.previousInternalNotes = [];
    this.internalNotesList = [];
    this.patientId = "";
    this.selectedPatient = null;
    this.patientInfoDisplay = "";
    this.patientImage = "";
    this.defaultDeposit = "";
    this.formRegistration.reset();
    this.formEncounter.reset();
    this.formRegistration.enable();
    this.isSave = true;
    this.formRegistration.controls["expiryDate"].setValue("");
    this.formRegistration.controls["expiryDate"].disable();

    let patientEncounterPayer = new PatientEncounterPayer();
    patientEncounterPayer.isSelf = true;
    this.dataSourcePayers = new MatTableDataSource<any>([
      patientEncounterPayer,
    ]);
    this.dataSourceEncounters = new MatTableDataSource<any>([]);
    this.getPayerTypeList();
    this.getPayerList();
    this.fillDropDownLists();
    this.getScreenConfigurations();
    this.pdpaForm = false;
    this.isFromAppointment = false;
    this.primaryIdSearch = null;
    this.identificationList = new MatTableDataSource<Identification>([]);
    this.selectedPatientIdentificationList=[];
    this.addEmptyIdentificationEntry("P");
  }

  /**
   *primary identification value
   *
   * @param {*} idTypeCode
   * @memberof SamplePatientRegistrationComponent
   */
   primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove:boolean,index?) {    
    var formRegistration = this.formRegistration.controls;
    if(isPrimaryNoRemove){
    this.identificationList.data[index].idType=idTypeCode.value;
    this.identificationList.data[index].idNumber="";
    if(this.identificationList.data[index].type=='P'){
     this.mandatoryField.identificationType=true;
     this.mandatoryField.identificationNo=true;
    }else{
     this.mandatoryField.secIdentificationType=true;
     this.mandatoryField.secIdentificationNo=true;
    }
    }
    if(this.identificationList.data[index].type=='P'){
    if (idTypeCode?.value) {
      this.primaryIdCode = this.primaryIdFilteredList.find(
        (s) => s.code == idTypeCode.value
      );
    }else{
        this.primaryIdCode = this.primaryIdFilteredList.find(
          (s) => s.code == idTypeCode.code
        );
      }
    }else{
      if (idTypeCode?.value) {
        this.primaryIdCode = this.secondaryIdFilteredList.find(
          (s) => s.code == idTypeCode.value
        );
      }else{
          this.primaryIdCode = this.secondaryIdFilteredList.find(
            (s) => s.code == idTypeCode.code
          );
        }
    }
      // let primaryIdCode = formRegistration.primaryId.value;
      if (this.primaryIdCode) {        
        this.primaryIdNewValue=this.primaryIdCode.code?this.primaryIdCode.code:"";
        if (this.primaryIdCode.isMyKad == true) {
          formRegistration["nation"].setValue("MALAYSIAN");
          this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
        } else {
          this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation
            ? this.primaryIdCode.validation
            : "";
        }
      }
      // if (!this.selectedPatient) {
        if (this.primaryIdCode.isExpireReq) {
          this.identificationList.data[index].isExpiryRequired = true;
        } else {
          this.identificationList.data[index].expDate="";
          this.identificationList.data[index].isExpiryRequired = false;
        }
        this.primaryNumberOnKeyUp(this.identificationList.data[index].idNumber,index);
      // }
      if (this.primaryIdCode.expiryDuration) {
        const currentDate = new Date().getFullYear();
        const maxExpiryDurationDate = new Date();
        maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);

        this.maxExpiry = maxExpiryDurationDate;
      }
      else{
        this.maxExpiry= new Date(this.year + 20, this.month, this.day);
      }
     if (this.primaryIdCode.validation) {
      this.identificationList.data[index].primaryIdRegex = this.primaryIdCode.validation;
       const match = this.identificationList.data[index].primaryIdRegex.match(/\{(\d+),(\d+)\}/);
       this.identificationList.data[index].minIdentificationLength = match ? parseInt(match[1], 10) : null;
       this.identificationList.data[index].maxIdentificationLength = match ? parseInt(match[2], 10) : null;
     }else{
      this.identificationList.data[index].maxIdentificationLength=25;
      this.identificationList.data[index].minIdentificationLength=0;
      this.identificationList.data[index].primaryIdRegex=OPD_CONST.primaryIdRegix;
     }
     this.formRegistration.controls["primaryNumber"].updateValueAndValidity();
     if(!this.identificationList.data[index].issuingCountry)
     this.identificationList.data[index].isCountryRequired = this.primaryIdCode ? this.primaryIdCode.isCountryRequired : false;
    
    this.primaryIdSelect(idTypeCode.value);
  }
  primaryIdSelect(value){
    this.isPrimaryNoEditable=value?true:false;
  }

  /**
   *
   *
   * @param {*} event
   * @memberof SamplePatientRegistrationComponent
   */
  editPatientClicked() {
    if (this.selectedPatient) {
      const formRegistration = this.formRegistration.controls;
      const IdTypeCode = formRegistration["IdTypeCode"].value;

      if (IdTypeCode) {
        this.isexpiryDate = IdTypeCode.isExpireReq;

        if (!this.isexpiryDate) {
          formRegistration["expiryDate"].setValue("");
          formRegistration["expiryDate"].disable();
          this.isexpiryDate = true;
        } else {
          formRegistration["expiryDate"].enable();
          this.isexpiryDate = false;
        }
      }
    }
  }

  /**
   *
   *
   * @param {*} prefixvalue
   * @memberof SamplePatientRegistrationComponent
   */
  getGender(prefixvalue) {
    let formRegistration = this.formRegistration.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["gender"].disable();
    } else {
      this.genderValue = this.defaultGender ? this.defaultGender.code :"";
      formRegistration["gender"].enable();
    }
  }

  primaryNumberOnKeyUp(value: string,index?) {
    this.identificationList.data[index].idNumber=value;
    try {
      let formRegistration = this.formRegistration.controls;
      let primaryIdCode = this.identificationList.data[index].idType

      value = value.replace(/\s/g, '');
      this.identificationList.data[index].idNumber=value;
      if (primaryIdCode) {
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode
        );
        if (primaryIdentify) {
          if (primaryIdentify.isMyKad) {
            value = value.replace(/[^\d*]/g, '');
            this.identificationList.data[index].maxIdentificationLength=14;
            this.identificationList.data[index].minIdentificationLength=0;
            var r = /[^0-9*]+/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            this.identificationList.data[index].idNumber=value ? value : "";
            this.identificationList.data[index].primaryIdRegex = "^[0-9 -]+$";
          } else if (primaryIdentify.isMyKad == false) {
            this.identificationList.data[index].primaryIdRegex = "[A-Za-z0-9]*";
            this.identificationList.data[index].idNumber=value ? value : "";
          }

          if (value.length >= 12 && primaryIdentify.isMyKad) {
            const array = Array.from(c);
            const yearSuffix = parseInt(array[0] + array[1], 10);
            const cal_month = parseInt(array[2] + array[3], 10);
            const cal_day = parseInt(array[4] + array[5], 10);
            const contry = array[6] + array[7];
            const gen_val = array[11];
  
            BirthPlaceList.forEach(element => {
              if (element.birthPlaceNumber == contry) {
                this.formRegistration.patchValue({
                  birthplace: element.birthPlaceName
                });
              }
            });

            const lastDigit = Number(gen_val);
            let genderVal = lastDigit % 2 == 0 ? STATICCODESERVICE.GENDER_MASTER_FEMALE : STATICCODESERVICE.GENDER_MASTER_MALE;
            this.genderValue = this.patientRegService.getCodeByStaticCode(this.genderList, genderVal);
  
            var currentYear = new Date().getFullYear();
            var currentYearSuffix = currentYear % 100;
  
            let yr;
            if (yearSuffix > currentYearSuffix) {
              yr = 1900 + yearSuffix;
            } else {
              yr = 2000 + yearSuffix;
            }
  
            var birthDate = new Date(yr, cal_month - 1, cal_day);
            var today = new Date();
  
            if (birthDate > today && !this.isSameDate(birthDate, today)) {
              yr -= 100;
              birthDate = new Date(yr, cal_month - 1, cal_day);
            }
            
            if (this.isValidDate(yr, cal_month, cal_day)) {
              formRegistration["dateOfBirth"].setValue(birthDate);
              formRegistration["realdob"].setValue(true);
            } else {
              this.snackBar.open(
                this.langService.get("CommonAppoinment.InvalidNRIC"),
                this.langService.get("CommonAppoinment.validation"),
                { duration: 1000 }
              );
              this.identificationList.data[index].idNumber="";
              formRegistration["birthplace"].setValue(null);
              this.genderValue = "";
              formRegistration["dateOfBirth"].setValue(null);
              formRegistration["realdob"].setValue(false);
            }
          }
        }
      }
    } catch (ex) {}
  }
  
  /**
   *
   *
   * @param {string} value
   * @memberof SamplePatientRegistrationComponent
   */
  onFocusOutEvent(value: any , index: number) {
    if(value.type=="P"){
      this.validationOnPrimarynumber(this.identificationList.data[index]?.idNumber ,index);
    }
    if (value.identifierUUID && this.patientId) {
      value.identifierOverride = true;
      value.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
    let primaryIdCode:any = this.getObjByCode(
      this.identificationList.data[index]?.type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
      this.identificationList.data[index]?.idType
    );
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && this.identificationList.data[index]?.idNumber.length < 14)
        this.identificationList.data[index].isIdNumberValid=false;
      else
        this.identificationList.data[index].isIdNumberValid=true;
    }
  }

  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof SamplePatientRegistrationComponent
   */
   validationOnPrimarynumber(value: string , index:number) {
    if (value) {
      let input = value;
      this.output = input.replace(/-/g, '');
    }
    if (this.selectedPatientIdentificationList[index].idNumber!==value) {
    // if (this.patientId == "" && value.length > 0) {
      let primaryIdCode = this.identificationList.data[index].idType;
      if (primaryIdCode) {
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response:any) => {
            if(response && response.status==409){
              this.identificationList.data[index].idNumber="";
            }else{
              this.identificationList.data[index].idNumber=value;
            }
          });
      }
    }
  }


  /**
   *Calcuate DOB
   *
   * @param {string} age
   * @param {string} month
   * @memberof SamplePatientRegistrationComponent
   */
   calculateDob(age: string, month: string) {
    let formRegistration = this.formRegistration.controls;

    let agecalc;
    let monthcalc;

    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
    var todayDate = new Date();
    var ageyear = todayDate.getFullYear() - Number(agecalc);
    var agemonth = todayDate.getMonth() - Number(monthcalc);
    var ageday = todayDate.getDate() - 0;
    formRegistration["dateOfBirth"].setValue(new Date(ageyear, agemonth, ageday));
  }


  /**
   *
   *
   * @param {*} departmentCode
   * @memberof SamplePatientRegistrationComponent
   */
  getDoctorList(departmentCode) {

      this.departmentFilterList =departmentCode?.value=="null"?this.departmentList:this.departmentFilterList;
      let depCode=departmentCode==null ?null:departmentCode.code?departmentCode.code:departmentCode.value.code;
      let payload = {
        departmentCode:depCode,
        typeCodeList:["DR"],

      };
      this.masterApiService
        .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST, payload)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          let list = [];
          let letmultilangdoclist = [];
          if (
            data &&
            data.payload &&
            data.payload.employeeResponseList &&
            data.payload.employeeResponseList.length > 0
          ) {
            data.payload.employeeResponseList.forEach((element) => {
              list.push({
                id: element.id,
                code: element.code,
                desc: element.desc,
              });
              letmultilangdoclist.push(element);
              if (this.previousEncounterList.length > 0)
                this.formEncounter.controls["doctor"].setValue(this.doctorValue);
            });
          }
          this.multiLangDoctorList = letmultilangdoclist;
          this.doctorFilteredList = list;
          this.docList = list;
        });
    
  }

  /**
   *
   *
   * @param {*} event
   * @memberof SamplePatientRegistrationComponent
   */
  getSpeciality(event){
    if(event.value){
      this.masterApiService
        .postTypeMaster(OPD_API_URL.GET_SPECIALITY_BY_DOCTOR+event.value, '')
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          if(data.payload){
            this.departmentFilterList =data.payload;
            this.departmentValue= data.payload[0];
          }
        })
    }
  }

  /**
   *
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getdepartment() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.DEPT_GET_DEPT_BY_UNIT)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.departmentList = data;
        this.departmentFilterList=data;
      });
  }
  
  /**
   *Get Payerlist
   *
   * @memberof SamplePatientRegistrationComponent
   */
  getPayerList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_COMPANY)
        .subscribe((data: any) => {
          this.payerList = data;
          this.payerFilteredList = data;
          if(!this.selectedPatient){
          let res = this.payerList.find((s) => s.isSelf == true);
          this.dataSourcePayers.data[0].payerCode = res.code;}
          this.dataSourcePayers.data[0].payerList = []
          this.dataSourcePayers.data[0].payerList = data;
          this.dataSourcePayers.data[0].payerFilteredList = data;
          // this.getPayerTypeList();
        })
    );
  }

  /**
   *It is the source of payerType data.
   *
   * @memberof PatientRegistrationComponent
   */
  getPayerTypeList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_COMPANYTYPE)
        .subscribe((data: any) => {
          this.payerTypeList = data;
          this.payerTypeFilteredList = data;
          let res = this.payerTypeList.find((s) => s.isSelf == true);
          this.dataSourcePayers.data[0].payerTypeCode = res.code;
          // this.getPayerListData(res.code, 0);
        })
    );
  }

  /**
   *getPayer type list
   *
   * @param {*} referralTypeCode
   * @memberof SamplePatientRegistrationComponent
   */
  getReferralList(referralTypeCode) {
    if (referralTypeCode) {
      this.referralTypeCode = {
        field: OPD_API_URL.M_REFFERALTYPE,
        value: referralTypeCode.id,
      };
      this.isOtherReferral = referralTypeCode.desc.trim() === 'Others';
    }
    else {
      this.isOtherReferral = false; 
    }
  }

  /**
   *It is get the tariffMaster Data
   *
   * @memberof PatientRegistrationComponent
   */
  getTariffmaster() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_TARIFF)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        this.tariffList = res;
        this.tariffFilteredList = res;
  
        // ✅ Bind tariff list to each row
        // this.dataSourcePayers.data.forEach((payer, index) => {
          // if (!payer) return;
          // payer.tariffList = [...res];
          // payer.tariffFilteredList = [...res];
  
          // ✅ Auto-select default tariff
          // let defaultTariff = res.find((t) => t.isDefault);
          // if (defaultTariff) {
          //   payer.tariffCode = defaultTariff.code;
          //   payer.isDisableTariff = true;
        //   }
        // });
  
        // ✅ Refresh table data
        this.dataSourcePayers._updateChangeSubscription();
      });
  }

  /**
   *
   *
   * @memberof PatientRegistrationComponent
   */
  getContractListData() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_CONTRACT)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.contractList = data;
        this.contractCodeList = data;
  
        // ✅ Bind contract list to each row
        this.dataSourcePayers.data.forEach((payer, index) => {
          if (!payer) return;
          payer.contractList = [...data];
          payer.contractCodeList = [...data];
        });
  
        // ✅ Refresh table data
        this.dataSourcePayers._updateChangeSubscription();
      });
  }

  /**
   *It is the source of getAssociateList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getAssociatedCompanyList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_ASSOCIATECOMPANY)
        .subscribe((data: any) => {
          this.associatedCompanyList = data;
          this.associatedCompanyCodeList = data;
          this.dataSourcePayers.data.forEach((payer, index) => {
            if (!payer) return;
            payer.associatedCompanyList = [...data];
            payer.associatedCompanyCodeList = [...data];
          });
    
          // ✅ Refresh table data
          this.dataSourcePayers._updateChangeSubscription();
        })
    );
  }

  /**
   *It is the source of primaryId data
   *
   * @memberof PatientRegistrationComponent
   */
  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.primaryIdList = data.filter((i) => i.isPrimaryId);
        this.primaryIdFilteredList = this.primaryIdList;
        this.secondaryIdList = data.filter((i) => !i.isPrimaryId);
        this.secondaryIdFilteredList = data;
      });
  }

  /**
   *It is the source of visit reason
   *
   * @memberof PatientRegistrationComponent
   */
  getReasonList() {
      this.masterApiService
      .getTypeMaster(OPD_API_URL.M_REASON_MASTER_QUERY_NEW + OPD_CONST.quickReason,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.reasonSample = data;
        this.reasonList = data;
      });
  }

  /**
   *It is the source of getGLTypeList data.
   *
   * @memberof PatientRegistrationComponent
   */
  getGLTypeList() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_GLTYPE)
        .subscribe((data: any) => {
          this.glTypeList = data;
        })
    );
  }

  /**
   *Change Priority
   *
   * @param {boolean} moveUp
   * @param {number} index
   * @memberof SamplePatientRegistrationComponent
   */
  changePayerPriority(moveUp: boolean, index: number) {
    let list = this.dataSourcePayers.data;
    var element = list[index];
    if (moveUp && index > 0) {
      list.splice(index, 1);
      list.splice(index - 1, 0, element);
    } else if (!moveUp && index != list.length - 1) {
      list.splice(index, 1);
      list.splice(index + 1, 0, element);
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }

  /**
   *remove payer
   *
   * @param {*} index
   * @memberof SamplePatientRegistrationComponent
   */
  removePayer(element) {
    let list = this.dataSourcePayers.data;
    const index: number = list.indexOf(element);
    list.splice(index, 1);
    this.dataSourcePayers = new MatTableDataSource<any>(list);
  }

  /**
   *Add payer
   *
   * @memberof SamplePatientRegistrationComponent
   */
  addPayer() {
    let list = this.dataSourcePayers.data;
    let patientEncounterPayer = new PatientEncounterPayer();
    patientEncounterPayer.payerCode = "";
    patientEncounterPayer.priority = list.length + 1;
    if(!this.isFirstPayerPriority){
      list.push(new PatientEncounterPayer());
    }else{
      list.unshift(new PatientEncounterPayer());
    }
    this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);

    // let list = this.dataSourcePayers.data;
    // let patientEncounterPayer = new PatientEncounterPayer();
    // patientEncounterPayer.priority = list.length + 1;
    // list.unshift(new PatientEncounterPayer());
    // this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(list);
  }
  getAppConfigurationList() {
    let mrdConfig: any;
      this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
      this.appBaseService
        .getResource( "appConfiguration/findConfigByModule?unitCode="+this.unitCode+
          "&orgCode="+this.orgCode+"&moduleName="
          +OPD_CONST.patientManagement+"&keyName=")
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
        if (res) {
          mrdConfig = res.keys;
          mrdConfig.forEach((element) => {
            if (element.key == "PatientCategoryTariffMapperRequired") {
              this.isPatientCategory =
                element.valueList[0].code == "true" ? true : false;
            }
            if (element.key == MasterKeys.DefaultCountryCode){
              if (element.valueList.length > 0) {
                this.defaultCountry = element.valueList[0]?.code;
                let code = this.countryCodeLists.filter(i=>i.code ==element.valueList[0]?.code);
                this.countryCode = element.valueList[0].code;
                this.setPatternToMobileNumber(code[0]);
              }
            }
          });
        }
      });
  }
  getCountryCode() {
    this.masterApiService
      .getTypeMaster(this.masterAPI.COUNTRY_CODE_MASTER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryCodeLists = data;
      });
  }

  /**
   *Passing payerCode and index to get the contractList
   *
   * @param {*} payerCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  getPayerListData(payerTypeCode, element) {
    let resPayerCode = this.payerTypeList.find((s) => s.code == payerTypeCode);
    if (resPayerCode.isSelf && this.dataSourcePayers.data.length > 1) {
      let index = this.dataSourcePayers.data.indexOf(element);
      this.dataSourcePayers.data[index].payerTypeCode = "";

      this.snackBar.open(
        //"Please Select other Payer Type,Self already selected",
        this.langService.get("CommonAppoinment.selectotherpayertype"),
        this.langService.get("CommonAppoinment.validation"),
        {
          duration: 2000,
        }
      );
    } else {
      let res = this.payerList.find((s) => s.isSelf == resPayerCode.isSelf);
      this.dataSourcePayers.data[0].payerCode = res ? res.code : "";
    }
  }

  /**
   *Add internal notes
   *
   * @memberof SamplePatientRegistrationComponent
   */
  addInternalNotes() {
    const dialogRef = this.dialog.open(PatientNotesDialogComponent, {
      height: "350px",
      width: "1000px",
      data: {
        listNotes: this.previousInternalNotes,
        name: "Encounter",
        encounterId: this.internotesEncounterid,
        isPrint:false
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        let res = result;
        this.internalNotesList = res;
      })
    );
  }
  setPatternToMobileNumber(event){
    if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.formRegistration.controls["mobileNumber"].setValidators([
        Validators.required,
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      }else{
      this.formRegistration.controls["mobileNumber"].clearValidators();
      }
    } else {
      this.formRegistration.controls["mobileNumber"].clearValidators();
      this.formRegistration.controls["mobileNumber"].setValidators([
        Validators.required,
      ]);
    }
    this.formRegistration.controls["mobileNumber"].updateValueAndValidity();
  }
  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  getScreenConfigurations() {
    this.subscriptionList.add(
      this.applicationConfig
        .getScreenConfiguration("OPD", MasterSubMenus.SampleReg)
        .subscribe((config: any) => {
          if (config) {
            this.mandatorykeys.setMandatoryFormValues(config, mandatoryFields);
          }
        })
    );
  }
  isSameDate(date1, date2) {
    return date1.getFullYear() == date2.getFullYear() &&
           date1.getMonth() == date2.getMonth() &&
           date1.getDate() == date2.getDate();
  }
  isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
  }
  
  isValidDate(year, month, day) {
    if (month < 1 || month > 12) {
      return false;
    }
  
    let daysInMonth;
    if (month == 2) {
      daysInMonth = this.isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      daysInMonth = 30;
    } else {
      daysInMonth = 31;
    }
    return day > 0 && day <= daysInMonth;
  }
  // getTariffContract(contractCode,index){
  //   this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
  //   if (this.contractValue.tariffMaster) {
  //     this.getTariffList(index); 
  //   }
  // }

  getTariffContract(contractCode, index,contract) {
    if(contractCode){
    this.isContract = contract;
    this.contractValue = this.dataSourcePayers.data[index].contractList.find(i => i.code === contractCode);
    this.dataSourcePayers.data[index].tariffList = [];
    this.dataSourcePayers.data[index].tariffList.push(this.contractValue?.tariffMaster) ;
    this.dataSourcePayers.data[index].tariffCode=this.contractValue?.tariffMaster?.code;
  }else{
    this.isContract = false;
    this.getTariffList(index);
  }
  }

    /**
   *
   *
   * @param {*} contractCode
   * @param {*} index
   * @memberof PatientRegistrationComponent
   */
  
  // getTariffContractPayer(payerCode, index , company) {
  //   if(payerCode){
  //   this.isCompany = company;
  //   this.isContract = false;
  //     this.masterApiService
  //       .getTypeMaster(OPD_API_URL.GET_COMPANY_TARIFF_BY_COMPANYCODE + payerCode)
  //       .pipe(takeUntil(this._onDestroy))
  //       .subscribe((res: any) => {
  //         if (res) {
  //           this.tariffCompanyList = res.companyMasterDTOResponse?.tariffResponseList;
  //           this.getTariffList(index);
  //         } 
  //       });
  // }else{
  //   this.isCompany = false;
  // }
  // }
  getContractPayer(payerCode,index){
    this.dataSourcePayers.data[index].contractList = [];
    this.dataSourcePayers.data[index].contractCodeList = [];
   let payerId =  this.dataSourcePayers.data[index].payerList.find(i=> i.code ==payerCode);
    this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
    this.appBaseService
      .getResource(
        OPD_API_URL.GET_PAYERTYPE_TYPE  +
        "payerId="+payerId.id + "&visitTypeCode=OP"
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        let data = res;
        this.dataSourcePayers.data[index].contractList = data;
        this.dataSourcePayers.data[index].contractCodeList = data;
      })
  }
  getPayerTypePayer(payerCode,index){
    this.dataSourcePayers.data[index].payerList = []
    this.dataSourcePayers.data[index].payerFilteredList = []
    let payerTypeId =   this.payerTypeList.find(i=>i.code ==payerCode);
   
     this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
     this.appBaseService
       .getResource(
         OPD_API_URL.GET_CONTRACT_PAYER  +
         payerTypeId.id
       )
       .pipe(takeUntil(this._onDestroy))
       .subscribe((res) => {
         let data = res;
        this.dataSourcePayers.data[index].payerList = data;
        this.dataSourcePayers.data[index].payerFilteredList = data;
       })
   }
   getPreviousPayerList(mrn?) {
    this.existingPayerList = [];
    let glattachmentList = [];
   let mrnValue=mrn?mrn:"";
    this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.OPD_PAYER_ALL_DETAILS + mrnValue+"&visitType="+"OP")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res.length > 0) {
          res.forEach((ele) => {
            let referralNoList = [];
            glattachmentList = ele.glAttachmentList
              ? ele.glAttachmentList
              : null;
            if (glattachmentList && glattachmentList.length > 0) {
              glattachmentList.forEach((element) => {
                let list = {
                  glrefno: element.glAttachmentNo ? element.glAttachmentNo : "",
                  glbalance: element.availableBal ? element.availableBal : 0,
                  effectiveDate: element.effectiveDate
                    ? element.effectiveDate
                    : "",
                  expiryDate: element.expiryDate ? element.expiryDate : "",
                
                  glTypeCode: element.glType ? element.glType.code : "",
                  polictyNo: element.glReferenceNo ? element.glReferenceNo : "",
                };
                referralNoList.push(list);
              });
            }
            let obj = {
              payerTypeCode: ele.payerType ? ele.payerType.code : "",
              payerCode: ele.payer ? ele.payer.code : "",
              tariffCode: ele.tariff ? ele.tariff.code : "",
              glTypeCode:
              ele.company && ele.company.isAutoApproval
              ? statisGlApprovalType.AG
              : statisGlApprovalType.PG,
              effectiveDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].effectiveDate
                  : "",
              expiryDate:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].expiryDate
                  : "",
              isexpirypayerDate:true,
              glAmount:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glbalance
                  : "",
              glReferenceNo:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].glrefno
                  : "",
              policyNumber:
                referralNoList && referralNoList.length > 0
                  ? referralNoList[0].polictyNo
                  : "",
              contractCode: ele.contract ? ele.contract.code : "",
              associatedCompanyCode: ele.associatedCompany
                ? ele.associatedCompany.code
                : "",
              isSelf: ele.payerType.code === "SELF" ? true : false,
              referralNoList: referralNoList,
            };
            this.existingPayerList.push(obj);
          });
          this.dataSourcePayers = new MatTableDataSource<PatientEncounterPayer>(
            this.existingPayerList
          );
          this.getContractListData();
          this.getPayerList();
          this.getTariffmaster();
          this.existingPayerList.forEach((element ,i)=> {
          this.getPayerTypePayer(element.payerTypeCode,i);
          });
        }
      });
  }
  getGlType(element,index){
    let selectedPayer=element.payerList.find(e => e.code == element.payerCode );
     this.dataSourcePayers.data[index].glTypeCode = selectedPayer?.isAutoApproval ? statisGlApprovalType.AG : statisGlApprovalType.PG;
  }

    /**
   *It is the source of country data.
   *
   * @memberof SamplePatientRegistrationComponent
   */
   getCountryList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_COUNTRY)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.countryPrimaryList = data;
      });
  }
  onFocusOutEventOnKey(value: string) {
    let mrn = this.selectedPatient ? this.selectedPatient.mrn : "";
    let tokenNo = value ? value : "";
    if (mrn == "" && tokenNo == "") return false;
    this.generalApiService
      .getTypeApi(
        OPD_API_URL.PATIENT_INTEGRATION_SERVICE,
        "tokenNo=" + tokenNo + "&mrnNo=" + mrn
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res: any) => {
        if (res.message !== "") {
          this.snackBar.open("Info", res.message, {
            duration: 3000,
          });
          this.isToken = false;
          this.tokenNoValue = "";
        } else {
          this.isToken = true;
        }
      });
  }
  updateVIPStatus(event) {
    // if(event.checked) {
    //   this.isVip = true;
    //   this.formRegistration.controls["isVip"].setValue(true);
    //   this.formRegistration.controls["aliasName"].enable();
    //   this.formRegistration.updateValueAndValidity();
    // } else {
    //   this.isVip = false;
    //   this.formRegistration.controls["isVip"].setValue(false);
    //   this.formRegistration.controls["aliasName"].setValue("");
    //   this.formRegistration.controls["aliasName"].disable();
    //   this.formRegistration.updateValueAndValidity();
    // }
  }
  getDoctorReqOnEncounterType(event){
    let doctorControl = this.formEncounter.controls["doctor"];
    this.formEncounter.controls["doctor"].setValue("");
    if (event.isDoctorReq) {
      doctorControl.setValidators([Validators.required]);
      this.isDepartment = true;
      
    } else {
      doctorControl.clearValidators();
      this.isDepartment = false;
    }
    doctorControl.updateValueAndValidity();
  }
  addIdentification(element): void {
    const { idType, idNumber, expDate, issuingCountry, type, isIdNumberValid } = element;
  
    if (!idType || !idNumber) {
      this.snackBar.open("Please enter identification details", "validation", { duration: 2000 });
      return;
    }
    if(!isIdNumberValid){
      this.snackBar.open("Please enter valid identification Number","Validation",{duration:2000});
    }
    const idTypeCode:any = this.getObjByCode(
      type === 'P' ? this.primaryIdFilteredList : this.secondaryIdFilteredList,
      idType
    );
  
    if (idTypeCode.isExpireReq && !expDate) {
      this.snackBar.open("Please enter expiry date", "validation", { duration: 2000 });
      return;
    }
  
    if (idTypeCode.isCountryRequired && !issuingCountry) {
      this.snackBar.open("Please enter issuing country", "validation", { duration: 2000 });
      return;
    }
    const hasEmptyEntry = this.identificationList.data.some(
      item => !item.idType && !item.idNumber
    );
  
    if (hasEmptyEntry) {
      this.snackBar.open("Blank identification entry already exists", "validation", { duration: 2000 });
      return;
    }
   const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "Do you want to Add another identification entry?" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          this.addEmptyIdentificationEntry("S");
          this.secondaryIdentifierListModified = true;
        }
      })
    );
    
  }
  
  hasPrimarySelected(): boolean {
    return this.identificationList.data.some(item => item.type === 'P');
  }
  isIdTypeSelected(code: string, currentIndex: number): boolean {
    if(this.identificationList.data[currentIndex].type=="S"){
    return this.identificationList.data
      .some((item, index) => index !== currentIndex && item.idType === code);
    }
  }
  onTypeChange(element: string, index: number): void {
    this.identificationList.data[index].type=element;
    if (element === 'P') {
      this.identificationList.data.forEach((item, i) => {
        if (i !== index && item.type === 'P') {
          item.type = 'S';
        }
      });
    }
    this.identificationList.data[index].idType="";
    this.identificationList.data[index].idNumber="";
    this.identificationList.data[index].expDate="";
    this.identificationList.data[index].issuingCountry="";
    this.identificationList.data = [...this.identificationList.data]; 
  }
  setCountryValue(event: any, index: number, element: any): void {
    this.identificationList.data[index].issuingCountry = event;

    if (element.identifierUUID && this.patientId) {
      element.identifierOverride = true;
      element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
  }
  onExpiryDateChange(selectedDate: Date, element: any): void {
    element.expDate = selectedDate;
    if (element.identifierUUID && this.patientId) {
      element.identifierOverride = true;
      element.type=="P"?this.primaryIdentifierListModified = true:this.secondaryIdentifierListModified=true;
    }
  }
  deleteIdentification(index: number,element): void {
    if(this.selectedPatientIdentificationList && element.identifierUUID){
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
        width: "30%",
        data: { displayText: "deleteConfirm" },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          if (result != undefined && result.confirm && result.confirm == "yes") {
            this.appBaseService.setResourceURL(OPD_API_URL.OPD_SERVICE);
            this.appBaseService
              .deleteResource(OPD_API_URL.DELETE_IDENTIFICATION+this.patientId+"&identifierUUID="+element.identifierUUID)
              .subscribe((res) => {
                if(res.statusCode="200"){
                  this.snackBar.open(res.message,"Success",{duration:2000});
                if (index !== 0) {
                  const data = this.identificationList.data;
                  data.splice(index, 1);
                  this.identificationList.data = [...data];
                }
              }
              });
          }
        })
      );
    }else{
    if (index !== 0) {
      const data = this.identificationList.data;
      data.splice(index, 1);
      this.identificationList.data = [...data];
    }
  }
  }
  copyPrimaryId(element: any, index: number): void {
     const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "30%",
          data: { displayText: "Do you want to copy the primary identification?" },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result.confirm == "yes") {
    if(element.idType && element.idNumber){
    const original = this.selectedPatientIdentificationList.find(
      (item) => item.type === 'P' && !item.isCopied 
    );
  
    if (original) {
      const copiedElement = { ...original };
      copiedElement.isCopied = true;
      copiedElement.status = false;
      this.selectedPatientIdentificationList.push(copiedElement);
      original.idType = '';
      original.idNumber = '';
      original.expDate = '';
      original.issuingCountry = '';
      original.identifierUUID=undefined;
      original.isExpiryRequired=false;
      original.isCountryRequired=false;
      original.isCopied=false;
      this.primaryIdentifierListModified = true;
      this.identificationList.data = this.selectedPatientIdentificationList;
    }
    }
     }
      })
    );
  }
  addEmptyIdentificationEntry(type: 'P' | 'S'): void {
    this.identificationList.data.push({
      type: type,
      idType: '',
      idNumber: '',
      expDate: '',
      issuingCountry: '',
      maxIdentificationLength: 25,
      minIdentificationLength: 0,
      primaryIdRegex: OPD_CONST.primaryIdRegix,
      isIdNumberValid:true
    });
  
    this.identificationList.data = [...this.identificationList.data];
  }
}
